var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1012_4027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.7005 0H14.2995C6.4147 0 0 6.4147 0 14.2995V33.7005C0 41.5853 6.4147 48 14.2995 48H33.7005C41.5853 48 48 41.5853 48 33.7005V14.2995C47.9999 6.4147 41.5852 0 33.7005 0ZM43.1712 33.7005C43.1712 38.931 38.931 43.1712 33.7005 43.1712H14.2995C9.069 43.1712 4.8288 38.931 4.8288 33.7005V14.2995C4.8288 9.06891 9.069 4.8288 14.2995 4.8288H33.7005C38.931 4.8288 43.1712 9.06891 43.1712 14.2995V33.7005Z",
    fill: "url(#paint0_linear_1012_4027)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 11.5854C17.1546 11.5854 11.5854 17.1546 11.5854 23.9999C11.5854 30.8452 17.1546 36.4144 24 36.4144C30.8453 36.4144 36.4145 30.8452 36.4145 23.9999C36.4145 17.1545 30.8453 11.5854 24 11.5854ZM24 31.5857C19.8105 31.5857 16.4142 28.1895 16.4142 24C16.4142 19.8105 19.8105 16.4142 24 16.4142C28.1895 16.4142 31.5857 19.8105 31.5857 24C31.5857 28.1894 28.1894 31.5857 24 31.5857Z",
    fill: "url(#paint1_linear_1012_4027)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4386 14.6534C38.0816 14.6534 39.4134 13.3215 39.4134 11.6786C39.4134 10.0357 38.0816 8.70386 36.4386 8.70386C34.7957 8.70386 33.4639 10.0357 33.4639 11.6786C33.4639 13.3215 34.7957 14.6534 36.4386 14.6534Z",
    fill: "url(#paint2_linear_1012_4027)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1012_4027",
    x1: 24,
    y1: 47.8603,
    x2: 24,
    y2: 0.372824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E09B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C74C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C21975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7024C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1012_4027",
    x1: 24,
    y1: 47.8602,
    x2: 24,
    y2: 0.372784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E09B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C74C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C21975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7024C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1012_4027",
    x1: 36.4386,
    y1: 47.8602,
    x2: 36.4386,
    y2: 0.372757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E09B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C74C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C21975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7024C4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1012_4027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.2638ea261a3fd01932d4cd0a5c8baae3.svg";
export { ForwardRef as ReactComponent };